import Player from './player';
import Action from 'actions';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import {getDefaultExposure} from 'helpers/player-helper';
import Const from 'constants';
import {getPlayerProjOwnFunctionality} from 'helpers/projected-ownership';

export default class PlayerClassic extends Player {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('doublePosition');
        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('gameTeamPosName');
        builder.addTaskOnScenario('externalId');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('positionName');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        // if (data.hasOwnProperty('correlationStackingSettings')) {
        //     dispatch(Action.set('CorrelationStackingSettingsFromStorage', data.correlationStackingSettings));
        // }

        // if (data.hasOwnProperty('correlationStackingPlayers')) {
        //     dispatch(Action.set('UsageOfPlayersOnlyInCorrelationStacking', data.correlationStackingPlayers));
        // }

        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.set('TeamNameStackingFromStorage', data.teamNameStacking));
        }

        if (data.hasOwnProperty('avoidFewPassReceivers')) {
            dispatch(Action.set('AvoidFewPassReceiversFromStorage', data.avoidFewPassReceivers));
        }

        if (data.hasOwnProperty('flexMaxExposurePositions')) {
            dispatch(Action.set('FlexMaxExposurePositionsFromStorage', data.flexMaxExposurePositions));
        }
    }

    getExtraPlayerDataToStore({...rest}) {
        const {
            correlationStacking: {players},
        } = Action.getState();
        const correlationStackingPlayers = players.all();

        return {correlationStackingPlayers};
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        return {
            ...expandedPlayer,
            projOwn: {...getPlayerProjOwnFunctionality(expandedPlayer)},
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
                this.captain_exposureMin = getDefaultExposure('min');
                this.captain_exposureMax = getDefaultExposure('max');
            },
            isFitForLineup(substitutablePlayer) {
                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === Const.POSITION_FLEX) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['RB', 'WR', 'TE']));
                }
                if (substitutablePlayer.positionInLineup === Const.POSITION_DEF) {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['D']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
        };
    }
}
